// pages/NewPaidUsersSimple.jsx
import React, { useState, useEffect } from "react";
import { Card, Table, Button, Space, Typography, Spin, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { API_ENDPOINTS } from "../../config/api";
import { useGet } from "../../hooks/useApi";
import Toast from "../../utils/toast";

const { Title } = Typography;

const NewPaidUsersSimple = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  // API hook
  const { execute: fetchDashboardData } = useGet(
    API_ENDPOINTS.DASHBOARD_DATA,
    false,
  );

  // Load data
  const loadData = async () => {
    setLoading(true);
    try {
      const response = await fetchDashboardData();
      if (response?.status === true && response.data) {
        setUsers(response.data.new_paid_users || []);
      } else {
        Toast.error("Failed to load data");
      }
    } catch (error) {
      Toast.error("Error loading data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const formatCurrency = (amount, currency = "EUR") => {
    if (!amount) return "N/A";
    const symbols = { EUR: "€", USD: "$", INR: "₹" };
    return `${symbols[currency] || "€"}${amount.toFixed(2)}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  const getUserTypeColor = (type) => {
    const colors = {
      INDIVIDUAL: "blue",
      CLUB_COACH: "green",
      CLUB_ADMIN: "orange",
      KNKV_PARTICIPANT: "purple",
      SYSTEM_ADMIN: "red",
    };
    return colors[type] || "blue";
  };

  const columns = [
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: "User Type",
      dataIndex: "user_type",
      key: "user_type",
      render: (type, record) => (
        <Tag color={getUserTypeColor(type)}>
          {record.user_type_label || type}
        </Tag>
      ),
    },
    {
      title: "Plan",
      dataIndex: "subscription_plan",
      key: "subscription_plan",
    },
    {
      title: "Amount",
      key: "amount",
      render: (_, record) =>
        formatCurrency(record.amount_paid, record.currency),
    },
    {
      title: "Activation Date",
      dataIndex: "activation_date",
      key: "activation_date",
      render: (date) => formatDate(date),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Space style={{ marginBottom: "16px" }}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/dashboard")}
        >
          Back
        </Button>
        <Title level={4} style={{ margin: 0 }}>
          <CheckCircleOutlined
            style={{ color: "#52c41a", marginRight: "8px" }}
          />
          New Paid Users
        </Title>
      </Space>

      <Card>
        <Table
          dataSource={users}
          columns={columns}
          rowKey={(record, index) => index}
          loading={loading}
          pagination={{ pageSize: 10 }}
          locale={{ emptyText: "No new paid users found" }}
        />
      </Card>
    </div>
  );
};

export default NewPaidUsersSimple;
